module.exports = __webpack_public_path__ + "img/pedestrian-crash.6f0fe687.svg";